import request from '@/utils/request'

// 获取角色列表
export const getRoleList = () => request.get('/role/index')

export const addRole = (data) => request.post('/role/addRole', data)

export const editRole = (data) => request.post('/role/editRole', data)

export const deleteRole = (id) => request.post('/role/delRole', { id })


export const getAccountList = (params) => request.get('/account/index', { params })

export const addAccount = (data) => request.post('/account/addAccount', data)

export const editAccount = (data) => request.post('/account/editAccount', data)

export const deleteAccount = (id) => request.post('/account/delAccount', { id })

export const getUserAuthority = () => request.get('/authority/getAccountAuthority')




